import { render, staticRenderFns } from "./ContractInfo.vue?vue&type=template&id=6d8ddda8&scoped=true&lang=html"
import script from "./ContractInfo.vue?vue&type=script&lang=js"
export * from "./ContractInfo.vue?vue&type=script&lang=js"
import style0 from "./ContractInfo.vue?vue&type=style&index=0&id=6d8ddda8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8ddda8",
  null
  
)

export default component.exports